import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '../../components/Input';
import { Button } from '../../components/Button';
import FormGroup from '../../components/FormGroup';
import { Container, Form, SubmitArea } from './styles';
import formatCNPJ from '../../utils/formatCNPJ';
import useError from '../../hooks/useErrors';
import isCNPJValid from '../../utils/isCNPJValid';
import Loader from '../../components/Loader';
import httpClient from '../../datasources/httpClient';

export default function NewCompanyPage() {
  const { setError, removeError, getErrorMessageByFieldName } = useError();
  const navigate = useNavigate();

  const [internalId, setInternalId] = useState(0);
  const [storeId, setStoreId] = useState(0);
  const [cnpj, setCNPJ] = useState('');
  const [name, setName] = useState('');
  const [secret, setSecret] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  async function handleCreateNewCompany(event) {
    event.preventDefault();
    removeError('response');
    try {
      setIsLoading(true);

      const response = await httpClient.post('companies', {
        name,
        cnpj,
        storeId: parseInt(storeId, 10),
        internalCode: parseInt(internalId, 10),
        secret,
      });

      if (response.status === 202) {
        navigate('/new-backup');
      }
    } catch (error) {
      if (error?.response.data) {
        const { message } = error.response.data;

        setError({ fieldName: 'response', message });
      }
    } finally {
      setIsLoading(false);
    }
  }

  function handleChangeName(value) {
    setName(value);

    if (value.length < 3) {
      setError({ fieldName: 'name', message: 'O nome deve ter ao menos 3 caracteres' });
    } else {
      removeError('name');
    }
  }

  function handleChangeCNPJ(value) {
    setCNPJ(value);

    if (isCNPJValid(value)) {
      setError({ fieldName: 'cnpj', message: 'O cnpj informado é inválido' });
    } else {
      removeError('cnpj');
    }
  }

  return (
    <Container>
      <h1>Nova Empresa</h1>
      <Form onSubmit={(event) => handleCreateNewCompany(event)}>
        <FormGroup error={getErrorMessageByFieldName('name')}>
          <Input
            placeholder="Nome"
            value={name}
            onChange={({ target: { value } }) => handleChangeName(value)}
            error={getErrorMessageByFieldName('name')}
          />
        </FormGroup>
        <FormGroup error={getErrorMessageByFieldName('cnpj')}>
          <Input
            placeholder="CNPJ"
            value={formatCNPJ(cnpj)}
            onChange={({ target: { value } }) => handleChangeCNPJ(value)}
            error={getErrorMessageByFieldName('cnpj')}
          />
        </FormGroup>
        <Input
          placeholder="ID da loja"
          type="number"
          min="0"
          value={storeId}
          onChange={(event) => setStoreId(event.target.value)}
          id="storeInput"
        />
        <Input
          placeholder="ID wChamados"
          type="number"
          min="0"
          value={internalId}
          onChange={(event) => setInternalId(event.target.value)}
        />
        <Input
          placeholder="Senha de administrador"
          type="password"
          value={secret}
          onChange={(event) => setSecret(event.target.value)}
        />
        <SubmitArea>
          {getErrorMessageByFieldName('response') && <span>{getErrorMessageByFieldName('response')}</span>}
          {isLoading ? <Loader /> : <Button type="submit">Registrar Empresa</Button>}
        </SubmitArea>
      </Form>
    </Container>
  );
}
